import { render, staticRenderFns } from "./CowsDewormingThirdPage.vue?vue&type=template&id=5ae75e5c&scoped=true&"
import script from "./CowsDewormingThirdPage.vue?vue&type=script&lang=js&"
export * from "./CowsDewormingThirdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae75e5c",
  null
  
)

export default component.exports